import React, { useEffect, useRef } from 'react'

import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image'

import Swipers, { Pagination, Scrollbar, A11y, Autoplay, Navigation, Virtual, EffectFade } from 'swiper'
import useIsWindowWidthSmaller from 'hooks/useWindowWidth'

import classnames from 'classnames'
import * as styles from './index.module.less'
import 'swiper/swiper-bundle.css'
Swipers.use([Pagination, Scrollbar, A11y, Autoplay, Navigation, Virtual, EffectFade])

interface Ds2023ReviewSwiperPropsState {
  className?: string
  dataSource: {
    number: number
    link: string
    img_url: IGatsbyImageData
    year: number
    desc: string
  }[]
}

const Ds2023ReviewSwiper: React.FC<Ds2023ReviewSwiperPropsState> = ({ className, dataSource = [] }) => {
  const swiper = useRef<any>(null)
  const isMb = useIsWindowWidthSmaller()
  useEffect(() => {
    swiper.current = new Swipers('.Ds2023ReviewSwiper', {
      speed: 800,
      spaceBetween: 5,
      slidesPerGroup: !isMb ? 4 : 2,
      slidesPerView: !isMb ? 4 : 2,
      autoplay: false,
      allowTouchMove: true,
      pagination: {
        el: '.review-swiper-pagination',
        type: 'bullets',
      },
      navigation: {
        nextEl: '.review-swiper-button-next',
        prevEl: '.review-swiper-button-prev',
      },
    })
  }, [isMb])
  return (
    <div className={classnames(className, styles.container, 'relative')}>
      <div key={'ds2023ReviewSwiper' + isMb} className="Ds2023ReviewSwiper swiper-container ">
        <div className="swiper-wrapper ">
          {dataSource?.map((item, index) => (
            <div className="swiper-slide" key={index}>
              <div className="    text-[#fff]">
                <a href={item?.link} className={classnames('rounded-[4px] lg:rounded-[12px] block', styles.reviewCard)}>
                  <div className="h-full rounded-[4px] lg:rounded-[12px] overflow-hidden">
                    <GatsbyImage
                      className="w-full"
                      image={getImage(item?.img_url) as IGatsbyImageData}
                      alt={item?.desc}
                    />
                  </div>
                </a>
              </div>
              <div className="swiper-slide-content  bottom-0    text-[#fff] text-[12px]  ">
                <div className="text-[12px] line-clamp-1 lg:hidden">
                  {item?.year} {item?.desc}
                </div>
                <div className="hidden lg:block">
                  <p className="text-[12px]">{item?.year}</p>
                  <p className="text-[14px] line-clamp-1">{item?.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className={classnames(styles['swiperButtonNext'], 'review-swiper-button-next ')} />
      <div className={classnames(styles['swiperButtonPrev'], 'review-swiper-button-prev')} />
      <div className="review-swiper-pagination absolute lg:hidden "></div>
    </div>
  )
}

export default Ds2023ReviewSwiper
